export const setProducts = (data, store, index) => dispatch => dispatch({ type: 'SET_PRODUCTS', data, store, index });
export const unsetProducts = store => dispatch => dispatch({ type: 'UNSET_PRODUCTS', store });
export const removeProducts = (id, store, index) => dispatch => dispatch({ type: 'REMOVE_PRODUCTS', id, store, index });
export const loadProducts = data => dispatch => dispatch({ type: 'LOAD_PRODUCTS', data });
export const setPictures = data => dispatch => dispatch({ type: 'SET_DATA', data: { pictures: data } });
